// extracted by mini-css-extract-plugin
export default {"settings":"aDaAS3OF6owDu0LUwHlw","container":"ycmtWh_ehM434ZQmllkD"};